import fetch from '../utils/fetch';

//查询房型列表
export function getList(params) {
  return fetch({
    method:'POST',
    url:'houseTypeSearch/list',
    data:params
  })
}


//初始化房型列表商圈、地铁条件
export function initConditionByCityCode(params) {
  return fetch({
    method: 'GET',
    url:'/searchBase/initConditionByCityCode',
    params
  })
}

//初始化  城市
export function initCityList() {
  return fetch({
    method: 'GET',
    url:'/searchBase/initCityList'
  })
}

export function initCommonCondition(params) {
  return fetch({
    method: 'GET',
    url: '/searchBase/initCommonCondition',
    data:params
  })
}
export function getHouseTypeDetail(params) {
  return fetch({
    method:'GET',
    url:'/houseTypeSearch/houseTypeDetail',
    params
  })
}
